var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPositiveFlirting = function SvgPositiveFlirting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h270v270H0z",
    "data-name": "Hidden backgroun"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.25 143.65l-39.41-8m37.23-25.11a44.77 44.77 0 01-34.54 0m63.22 40.11a22 22 0 1143.91 0m-7.72-54.75a44.82 44.82 0 00-34.31 3.92",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 13.15
  })));
};
export default SvgPositiveFlirting;